module.exports = __webpack_public_path__ + "static/media/Chikorita_gaussian2.f155b0f8.png";